<template>
  <div class="container-con">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      text-color="#fff"
      active-text-color="#fff"
      :router="true">
      <el-menu-item index="/home">Pokerlovers</el-menu-item>
      <el-menu-item index="/shop">SHOP</el-menu-item>
      <el-menu-item index="/home">HOME</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  data () {
    return {
    }
  },
  computed: {
    activeIndex () {
      return this.$store.state.tab
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.el-menu.el-menu--horizontal {
  border-bottom: none;
  margin-left: -20px;
  background-color: rgba(255, 255, 255, 0);
  .el-menu-item {
    height: 68px;
    line-height: 68px;
  }
  .el-menu-item:nth-child(1) {
    font-size: 32px;
    border-bottom: none;
  }
  .el-menu-item:nth-child(n+2) {
    font-size: 16px;
    float: right;
  }
  .el-menu-item:hover {
    background-color: rgba(255, 255, 255, 0)!important;
  }
  .el-menu-item.is-active {
    color: rgb(255, 255, 255);
    border-bottom-color: rgb(255, 255, 255);
    background-color: rgba(255, 255, 255, 0)!important;
  }
}
</style>
